import { ASC, DESC } from "../constants";
import { getFullRouteWithQueryString } from "./commonMethods";

export const initializePayloadMethod = (action, others, state) => {
  let payload = {
    action,
    offset: state.offset,
    limit: state.limit,
  };
  if (state.sortDir && state.sortBy) {
    payload["sortBy"] = state.sortBy;
    payload["sortDir"] = state.sortDir.toUpperCase();
  }

  if (others) {
    payload = { ...payload, ...others };
  }
  return { payload };
};

export const currentCount = (offset, total, limit) => {
  offset = parseInt(offset);
  total = parseInt(total);
  limit = parseInt(limit);
  let limitCount = offset + limit;
  if (limitCount > total) {
    limitCount = total;
  }
  return limitCount !== 0 ? `${offset === 0 ? 1 : offset}-${limitCount}` : 0;
};

export const customCurrentCount = (offset, total, limit) => {
  offset = parseInt(offset);
  total = parseInt(total);
  limit = parseInt(limit);
  let limitCount = offset + total;
  // if (limitCount > total) {
  //   limitCount = total;
  // }
  return limitCount !== 0 ? `${offset === 0 ? 1 : offset}-${limitCount}` : 0;
};

export const payloadAfterPageChange = (
  pageNumber,
  component,
  listMethod,
  urlEndPoint,
  pathName
) => {
  component.setState(
    {
      currentPage: parseInt(pageNumber),
    },
    () => {
      let { payload } = component.listPayload;

      let temp = {
        ...payload,
        offset:
          (parseInt(component.state.currentPage) - 1) *
          parseInt(component.state.limit),
      };
      component.listPayload = { payload: temp };
      if (pathName) {
        const data = getFullRouteWithQueryString(pathName, {
          limit: component.state.limit,
          pageNumber: pageNumber,
        });

        component.props.history.push(data);
      }

      listMethod(urlEndPoint, component.listPayload);
    }
  );
};

export const payloadAfterCustomPageChange = (
  pageNumber,
  component,
  listMethod,
  urlEndPoint,
  pathName
) => {
  // console.log(pageNumber);
  component.setState(
    {
      currentPage: pageNumber,
      // ? component.state.currentPage + 1
      // : component.state.currentPage - 1,
    },
    () => {
      let { payload } = component.listPayload;

      let temp = {
        ...payload,
        offset:
          (parseInt(component.state.currentPage) - 1) *
          parseInt(component.state.limit),
      };
      component.listPayload = { payload: temp };
      if (pathName) {
        const data = getFullRouteWithQueryString(pathName, {
          limit: component.state.limit,
          pageNumber: pageNumber,
        });

        component.props.history.push(data);
      }

      listMethod(urlEndPoint, component.listPayload);
    }
  );
};

export const payloadAfterLimitChange = (
  value,
  component,
  listMethod,
  urlEndPoint,
  pathName
) => {
  component.setState(
    {
      limit: value,
      currentPage: 1,
      offset: 0,
    },
    () => {
      let { payload } = component.listPayload;

      let temp = {
        ...payload,
        offset:
          (parseInt(component.state.currentPage) - 1) *
          parseInt(component.state.limit),
        limit: component.state.limit,
      };
      component.listPayload = { payload: temp };

      if (pathName) {
        const data = getFullRouteWithQueryString(pathName, {
          limit: component.state.limit,
          pageNumber: 1,
        });
        component.props.history.push(data);
      }

      listMethod(urlEndPoint, component.listPayload);
    }
  );
};

export const handleSort = (name, component, listMethod, urlEndPoint) => {
  let { sortBy, sortDir } = component.state;
  if (sortBy === name) {
    sortDir = sortDir === ASC ? DESC : ASC;
  } else {
    sortBy = name;
    sortDir = ASC;
  }
  const { payload } = component.listPayload;
  let temp = { ...payload, sortBy, sortDir: sortDir.toUpperCase() };
  component.listPayload = { payload: temp };
  listMethod(urlEndPoint, component.listPayload);
  component.setState({ sortBy, sortDir });
};

export const payloadAfterFilter = (
  key,
  value,
  component,
  listMethod,
  urlEndPoint
) => {
  const { payload } = component.listPayload;
  let temp = {
    ...payload,
    filters: {
      ...payload.filters,
      [key]: value,
    },
  };
  component.listPayload = { payload: temp };
  listMethod(urlEndPoint, component.listPayload);
};
